import { MerchantId, SetHeaderService } from "@/helper/userHelper";
import { DepartmentModel } from "@/model/department/departmentModel";
import { DepartmentTableViewModel } from "@/model/department/departmentTableViewModel";
import service from "../baseHttpService";

class DepartmentService {
  DoCreateDepartment(department: DepartmentModel) {
    const _input = {
      merchantId: MerchantId(),
      data: department,
    };
    return service.peakPayrollAPI.post("/api/Department/CreateDepartment", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoUpdateDepartment(department: DepartmentModel) {
    const _input = {
      merchantId: MerchantId(),
      data: department,
    };
    return service.peakPayrollAPI.post("/api/Department/UpdateDepartment", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoUpdateDepartmentDeleted(departmentId: number) {
    const _input = {
      merchantId: MerchantId(),
      data: departmentId,
    };
    return service.peakPayrollAPI
      .post("/api/Department/UpdateDepartmentDeleted", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoUpdateDepartmentArchived(departmentDetail: any) {
    const _input = {
      merchantId: MerchantId(),
      data: {
        departmentId: departmentDetail.id,
        isArchived: departmentDetail.isArchived,
      },
    };
    return service.peakPayrollAPI
      .post("/api/Department/UpdateDepartmentArchived", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoGetDepartmentTable(departmentTableViewModel: DepartmentTableViewModel) {
    const _input = {
      merchantId: MerchantId(),
      data: departmentTableViewModel,
    };

    return service.peakPayrollAPI.post("/api/Department/GetDepartmentTable", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }

  DoGetDepartmentDetail(departmentId: number) {
    const _input = {
      merchantId: MerchantId(),
      data: departmentId,
    };

    return service.peakPayrollAPI
      .post("/api/Department/GetDepartmentDetail", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }

  DoGetDepartmentList() {
    const _input = {
      merchantId: MerchantId(),
    };

    return service.peakPayrollAPI.post("/api/Department/GetDepartmentList", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }

  DoGetDepartmentSuggestionCode() {
    const _input = {
      merchantId: MerchantId(),
    };
    return service.peakPayrollAPI
      .post("/api/Department/GetDepartmentSuggestionCode", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
}

export default new DepartmentService();
